/**
 在线运维--订单列表；配置管理--墙盒设备快速查询--订单信息
 */
import React, { Component } from "react";
import PropsType from "prop-types";
import "../../../assets/stylus/com/display/process.styl";
import WallBoxOrderInfo from "./order";

class WallBoxOrderInfoPage extends Component {
  constructor(props) {
    super(props);
    this.init();
    this.props = props;
    this.state = {
      currentPhase: "wallBox",
    };
  }

  init() {
    this.query = {
      page: "1",
      pagecount: "10",
    };
    if (window.LayoutTab && window.LayoutTab.tabParam) {
      this.query["wallBoxInfoData"] = window.LayoutTab.tabParam.wallBoxInfoData;
    }
  }

  componentDidMount() {
    if (window.LayoutTab && window.LayoutTab.tabParam) {
      // console.log("entry:", window.LayoutTab, "tabParam:", window.LayoutTab.tabParam);
      this.query["wallBoxInfoData"] = window.LayoutTab.tabParam.wallBoxInfoData;
    }
    // console.log("componentDidMount wallBoxInfoData:", this.query.wallBoxInfoData);
  }

  render() {
    const Content = (
      <div className="sc-page-content">
        <div>
          <WallBoxOrderInfo
            params={this.query.wallBoxInfoData}
            onAdd={this.props.onAdd}></WallBoxOrderInfo>
        </div>
      </div>
    );
    return Content;
  }
}

export default WallBoxOrderInfoPage;

WallBoxOrderInfoPage.propsType = {
  onAdd: PropsType.func,
};



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/wallBox/orderInfoPage.js